import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { descriptionField, genericUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';

export const dataTransferMetadata = {
  displayName: msg({
    message: 'Sold products: data transfer',
    context: 'Activity data schema name for data transfer',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    description: descriptionField,
    network_type: {
      displayName: msg({
        message: 'Network type',
        context: 'The display name for a dimension',
      }),
    },
    quantity: {
      displayName: msg({
        message: 'Data transfer time',
        context: 'Data transfer or streaming time by usage hours.',
      }),
      externalDescription: msg({
        message: 'Data transfer or streaming time by usage hours.',
        context: 'Download or streaming time',
      }),
    },
    unit: genericUnitField,
    use_case: {
      displayName: msg({
        message: 'Use case',
        context: 'The display name for a dimension',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
